module.exports = __webpack_public_path__ + "static/3-ddaedf4ef5ebec64ae80c05e064f4a72.png";